import { Alert, Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { TreatmentSelector } from '../../../../../common/components/selectors/TreatmentSelector'

const SelectTreatmentStep: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Stack gap={2}>
      <TreatmentSelector
        name="treatment"
        required
        label={t('doctor:referralDetails.chooseTreatment')}
      />
      <Alert sx={{ backgroundColor: 'primary.100' }} severity="info">
        {t('doctor:referralDetails.info')}
      </Alert>
    </Stack>
  )
}

export { SelectTreatmentStep }
